export const Conditional = ({ conditional, children }) => {
  if (conditional) {
    return children;
  }

  return null;
};
